type SectionHeadingProps = {
  index: string;
  title: string;
  id: string;
};

export function SectionHeading({ index, title, id }: SectionHeadingProps) {
  return (
    <div className="section-heading">
      <p className="section-index">{index}</p>
      <h2 id={id}>{title}</h2>
    </div>
  );
}
